import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Resolve, RouterStateSnapshot, UrlTree } from "@angular/router";
import { UserService } from "app/core/services/admin/user/user.service";
import { ProjectService } from "app/core/services/project/project/project.service";
import { Observable, forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { FluxConfigurationModule } from "./flux.module";

@Injectable({
    providedIn: FluxConfigurationModule,
})
export class FluxGuard implements CanActivate, Resolve<any> {
    constructor(private _service: ProjectService, private _userService: UserService) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return true;
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const projectId = route.parent.parent.parent.params.id;

        return forkJoin([
            this._service.getFlux(projectId),
        ]).pipe(
            map((data) =>   
                <any>{
                    flux: (data[0] as any).data,
                    projectId: projectId,
                }
            )
        );
    }
}
